import { createUseStyles } from "react-jss";
import { ITheme } from "../../../constants/theme";
import { BreakPointDesktop } from "../../../constants/dimension";

export const useStyles = createUseStyles((theme: ITheme) => ({
  content: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing.space24,
    width: "100%",
  },
  header: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: theme.spacing.space8,
    textAlign: "center",
  },
  /** Matches the sizes Dialog applies to its own title/description on desktop. */
  title: {
    [BreakPointDesktop]: {
      fontSize: "32px !important",
      lineHeight: "45px !important",
    },
  },
  description: {
    [BreakPointDesktop]: {
      fontSize: "18px !important",
      lineHeight: "25px !important",
    },
  },
  field: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  error: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing.space4,
    textAlign: "left",
  },
  errorIcon: {
    flexShrink: 0,
    fontSize: 16,
  },
  /** Each link is centred in its own half of the dialog, as in Figma. */
  links: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: theme.spacing.space16,
    textAlign: "center",
    "&.single": {
      gridTemplateColumns: "1fr",
    },
  },
  link: {
    justifySelf: "center",
    padding: `${theme.spacing.space4}px ${theme.spacing.space8}px`,
    border: "1px solid transparent",
    borderRadius: theme.radius.small,
    textDecoration: "underline",
    cursor: "pointer",
    [BreakPointDesktop]: {
      fontSize: "16px !important",
      lineHeight: "22.4px !important",
    },
  },
  resend: {
    alignSelf: "center",
    textAlign: "center",
    padding: `${theme.spacing.space8}px ${theme.spacing.space16}px`,
    border: "1px solid transparent",
    borderRadius: theme.radius.small,
  },
  resendActive: {
    cursor: "pointer",
  },
  /** Controller focus on "Send again" and the links: a white box, as in Figma */
  selected: {
    borderColor: "#FFFFFF",
  },
  resendCountdown: {
    color: "#FFFFFF",
    fontWeight: 700,
  },
  resendLink: {
    color: theme.colors.Primary,
    textDecoration: "underline",
  },
}));
